import axios, { AxiosError } from "axios";

// Define the API Base URL
//https://api.uomox.com/csadmin
//http://localhost:9000/csadmin
export const REDIRECT_URL = "https://api.uomox.com";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
console.log(API_BASE_URL);
// ✅ Create a reusable Axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("USER_TOKEN");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Helper function to extract error message
const getErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    return error.response?.data?.message || "An error occurred!";
  } else if (error instanceof Error) {
    return error.message;
  }
  return "An unknown error occurred!";
};

// ✅ GET Request Function
export const getRequest = async (endpoint: string, params = {}) => {
  try {
    const response = await api.get(endpoint, { params });
    return response.data;
  } catch (error) {
    throw getErrorMessage(error); // ✅ Extracts error message safely
  }
};

// ✅ POST Request Function
export const postRequest = async (endpoint: string, data: any) => {
  try {
    const response = await api.post(endpoint, data);
    return response.data;
  } catch (error) {
    throw getErrorMessage(error); // ✅ Extracts error message safely
  }
};

export const postFormDataRequest = async (endpoint: string, data: any, header:any) => {
  try {
    const response = await api.post(endpoint, data,header);
    return response.data;
  } catch (error) {    
    throw getErrorMessage(error);
  }
};


export default api;
